import React from 'react'
import Posterpic from '../Images/running.png';

export const Poster = () => {
  return (
    <div className='poster' id='about'>
        <div className="postercontainer">
            <div>
                <img src={Posterpic} alt=''/>
            </div>
            <div className='postercontent'>
              
                <h2>Get Fit With Personal Fitness Trainer</h2>
                <p className='posterpara'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi quisquam inventore impedit adipisci suscipit voluptatum expedita aliquid dolor labore</p>
                <p className='posterpara activepara'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi quisquam   suscipit voluptatum expedita aliquid dolor labore consectetur adipisicing</p>
                <p className='posterpara'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi quisquam inventore impedit adipisci suscipit voluptatum expedita aliquid dolor labore consectetur</p>
            </div>
        </div>
    </div>
  )
}
